import { Global } from '@/store/globalz';
import assetx from '@/store/modules/assetx';
import { Dictionary } from '@/util/dictionary';
import { nonReact } from '@/util/nonReact';
import { Loader } from 'pixi.js';
import { SkinGachaControl } from '../controls/skinGachaControl';

declare const gac: any;
let loading = false;

const assetLoader = nonReact(new Loader());
for (const id in gac.gachaAssets.assets) {
	if (Object.prototype.hasOwnProperty.call(gac.gachaAssets.assets, id)) {
		const asset = gac.gachaAssets.assets[id];
		assetLoader.add(id, asset);
	}
}
export function loadGachaAssets() {
	if (loading) {
		return;
	}
	assetx.updateGachaLoadState('loading');
	loading = true;
	assetLoader.onComplete.once(onLoadComplete);
	assetLoader.onError.add(onError);
	assetLoader.onLoad.add(onLoad);
	assetLoader.load();
}

function onError(error: Error, loader: Loader, resources: any) {
	assetx.addLoadError(error);
}
function onLoad(loader: Loader, resource: any) {
	assetx.updateGachaLoadProgress(loader.progress);
	assetx.updateGachaLoadState('loading');
}
function onLoadComplete(loader: Loader, resources: Dictionary<any>) {
	assetx.updateGachaLoadState('completed');
	Global.skinGachaControl = nonReact(new SkinGachaControl());
	Global.skinGachaControl.resize(Global.width, Global.height);
}
